import { FiboSearchHeadline, FiboSearchType, TaxonomyType } from '../../constants';

export type FiboHeadline = {
  value: FiboSearchHeadline;
  type: FiboSearchType.HEADLINE;
};

export type FiboTaxonomyItem = {
  termId: string;
  taxonomy: TaxonomyType;
  value: string;
  url: string;
  imageSrc: string;
  breadcrumbs: string;
  count: string;
  type: FiboSearchType.TAXONOMY;
  score: number;
};

export type FiboProductItem = {
  postId: string;
  value: string;
  url: string;
  thumbHtml: string;
  price: string;
  desc: string;
  sku: string;
  onSale: boolean;
  featured: boolean;
  type: FiboSearchType.PRODUCT;
};

export type FiboCollectionItem = FiboTaxonomyItem | FiboProductItem;

export type FiboSuggestionItem = FiboHeadline | FiboCollectionItem;

// <----- only use for the HeaderSearchInput Combobox

export type FiboTaxonomyComboboxItem = FiboTaxonomyItem & { label: string };

export type FiboProductComboboxItem = FiboProductItem & { label: string };

export type FiboCollectionComboboxItem = FiboTaxonomyComboboxItem | FiboProductComboboxItem;

export type FiboSuggestionComboboxItem = FiboHeadline | FiboCollectionComboboxItem;

export type GroupedFiboHeadlineWithItems = FiboHeadline & {
  items: FiboCollectionComboboxItem[];
};
export type GroupedFiboSuggestionItemList = Array<[FiboSearchHeadline, GroupedFiboHeadlineWithItems]>;

// only use for the HeaderSearchInput Combobox ---->
